import { useQuery } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import {
  ArticleResponseItem,
  AuthorInfoParams,
  SimpleArticleItem,
} from '@/shared/types';
import { PATH } from '@/shared/constants';

const PAGE = 1;
const PAGE_SIZE = 5;

const useAuthorProfileArticleList = ({
  authorId,
  articleId,
}: AuthorInfoParams) => {
  return useQuery({
    queryKey: ['authorArticle', authorId, 'latest', PAGE, articleId],
    queryFn: async () => {
      const { data } = await clientAxios.get('/authorArticleListApi/', {
        params: {
          authorId,
          ordering: 'latest',
          page: PAGE,
          pageSize: PAGE_SIZE,
        },
      });

      const list: SimpleArticleItem[] = data.data.results
        .map((item: ArticleResponseItem) => {
          const { id, title, category } = item;
          return {
            id,
            href: `${PATH.DETAIL}/${id}`,
            title,
            category: category[0].name,
            categoryFlag: category[0].flag,
          };
        })
        .filter((item: SimpleArticleItem) => item.id !== articleId)
        .slice(0, PAGE_SIZE);

      return list;
    },
  });
};

export default useAuthorProfileArticleList;
